import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('vericred_imports',
  '/vericred_imports',
  'vericred_import')
const actions = generator.generate()

export default actions
